import _extends from '@babel/runtime/helpers/esm/extends';
import _inheritsLoose from '@babel/runtime/helpers/esm/inheritsLoose';
import React from 'react';
import classNames from 'clsx';
import { polyfill } from 'react-lifecycles-compat';

var FlashChange =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(FlashChange, _React$Component);

  function FlashChange() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.state = {
      activeFlash: false,
      props: _this.props
    };
    _this._timer = void 0;

    _this._deactivateTimer = function () {
      _this.setState({
        activeFlash: false
      });
    };

    return _this;
  }

  var _proto = FlashChange.prototype;

  _proto._activateTimer = function _activateTimer() {
    var flashDuration = this.props.flashDuration;

    if (this._deactivateTimer) {
      clearTimeout(this._deactivateTimer);
    }

    this._timer = setTimeout(this._deactivateTimer, flashDuration);
  };

  FlashChange.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
    var compare = nextProps.compare;
    var result = compare(prevState.props, nextProps);

    if (result) {
      return {
        activeFlash: true,
        compareResult: result,
        props: nextProps
      };
    }

    return {
      props: nextProps
    };
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    if (this.state.activeFlash) {
      this._activateTimer();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this._timer) {
      clearTimeout(this._timer);
    }
  };

  _proto.render = function render() {
    var _classNames, _classNames2;

    var _this$props = this.props,
        style = _this$props.style,
        className = _this$props.className,
        children = _this$props.children,
        flashClassName = _this$props.flashClassName,
        flashStyle = _this$props.flashStyle,
        outerElementType = _this$props.outerElementType;
    var _this$state = this.state,
        activeFlash = _this$state.activeFlash,
        compareResult = _this$state.compareResult;

    var styleProp = _extends({}, style);

    if (activeFlash) {
      styleProp = _extends({}, styleProp, flashStyle);
    }

    var OuterElement = outerElementType;
    return React.createElement(OuterElement, {
      style: styleProp,
      className: classNames(className, (_classNames = {}, _classNames[flashClassName] = activeFlash, _classNames), (_classNames2 = {}, _classNames2[compareResult] = activeFlash, _classNames2))
    }, children);
  };

  return FlashChange;
}(React.Component);

FlashChange.defaultProps = {
  flashDuration: 200,
  flashStyle: {},
  flashClassName: undefined,
  outerElementType: 'div',
  compare: function compare(prevProps, newProps) {
    return prevProps.value !== newProps.value;
  }
};
polyfill(FlashChange);

export default FlashChange;
